import React, { useContext, useState } from 'react';
import LoginHeader from '../../components/Headers/LoginHeader';
import LoginFooter from '../../components/Footers/LoginFooter';
import EmailTemplateEdit from '../../components/EmailTemplateEdit';
import { UserContext } from '../../context/User';
import AdminHeader from '../../components/Headers/AdminHeader';

const EmailTemplateEditPage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;
  const [trigger, setTrigger] = useState(false);

  return (
    <>  
      {role === "admin" ? <AdminHeader trigger={trigger} /> : <LoginHeader trigger={trigger} />}
      <main>
        <EmailTemplateEdit 
          setTrigger={setTrigger}
          trigger={trigger}
        />
        
      </main>
      <LoginFooter />
    </>
  )
}

export default EmailTemplateEditPage;
